<template>
    <div>
        <div class="card-body pb-0">
            <div style="margin-bottom: 50px;">
              <div>
                <strong v-if="!vimeoSource">Upload the final video</strong>
                <strong v-if="vimeoSource">Review the final video</strong>
              </div>
              <br>
                <div class="custom-file" v-if="!vimeoSource && !uploadStarted">
                    <input type="file" :id="'file' + target.id" class="custom-file-input"
                           @change="handleFileUpload($event,target.id)" accept=".mp4"/>
                    <label class="custom-file-label" :for="'file' + target.id">{{fileInputText}}</label>
                </div>
                <div class="alert alert-danger" role="alert" v-if="errorText.length > 0">
                    {{errorText}}
                </div>

                <div class="btn-group" v-if="!uploadStarted">
                    <button class="btn btn-small btn-danger" v-if="file && !vimeoSource && durationCheck"
                            @click="cancelUpload()">Cancel
                    </button>
                    <br>
                    <button class="btn btn-info" style="margin-left: 10px"
                            v-on:click="submitFileWithTus({participation:target, type:type})"
                            v-if="!vimeoSource && file  && !uploadStarted">Submit
                    </button>
                </div>

                <div class="upload-progress"
                     v-if="!vimeoSource && uploadStarted && activeParticipationUpload == target.id">
                    <span style="margin-left:10px">Video is uploading...</span>
                    <div
                            class="progress-bar bg-success"
                            role="progressbar"
                            v-bind:aria-valuenow="percentage"
                            aria-valuemin="0"
                            aria-valuemax="100"
                            :style="{width: percentage+'%'}"
                    >{{percentage}}
                    </div>
                </div>


                <div class="alert alert-primary" role="alert" v-if="vimeoSource && transcodeStatus[vimeoSource] != 'complete'"  @click="reloadPage()">
                    <div class="row">
                        <div class="col-sm-10" style="display: block;margin: auto 0;">
                            your video is converted now, click here to see if converting is ready
                        </div>
                    </div>
                </div>

                <div v-if="vimeoSource && transcodeStatus[vimeoSource] == 'complete'" style="width:30%">
                    <div style="margin-top:10px;position:relative; width:100%;padding-top:65%" v-if="vimeoSource">
                        <iframe id="vimeoIframe"
                                :src="vimeoSource"
                                style="position:absolute;top:0;left:0;width:100%;height:100%;"
                                frameborder="0"
                                allow="autoplay; fullscreen"
                                allowfullscreen
                        ></iframe>
                    </div>
                    <div class="row" v-if="vimeoSource">

                        <div class="col ">
                            <div class="row">
                                <div class="col text-right pr-0" style="margin: auto 0;font-size:2.4rem; color:#dc3545" ></div>
                                <div class="col-4 mr-2 pl-2"> <button class="btn btn-danger mt-2" v-if="vimeoSource"
                                                                      @click="clearVideo(target)">&nbsp;remove video
                                </button></div>
                            </div>
                        </div>
                    </div>

                </div>


                <div class="mb-2" v-if="target.video_upload_link">
                    <p>upload exists</p>
                    <button class="btn btn-danger mt-2" @click="clearVideoUpload(target)">
                        &nbsp;remove upload
                    </button>
                </div>

            </div>
        </div>

    </div>
</template>

<script>
    import {mapGetters, mapMutations, mapActions} from 'vuex';

    export default {
        name: 'Overview',
        components: {},
        props: ['target', 'type'],
        data() {
            return {

                file: null,
                checked: false,
                fileInputText: '',
                errorText: '',
                durationCheck: false,
                videoReady: false
            };
        },
        created() {
            this.fileInputText = 'Upload video';
        },
        computed: {
            ...mapGetters('videoUpload', ['videoName', 'percentage', 'uploadStarted', 'activeParticipationUpload', 'transcodeStatus']),

            vimeoSource() {

              if(this.type == 'session'){
                if(this.target.ondemand_link){
                  this.checkVideoStatus(this.target.ondemand_link)
                }
                return this.target.ondemand_link ? this.target.ondemand_link : null; //example  https://player.vimeo.com/video/429297333?title=0&byline=0&portrait=0
              } else if(this.type == 'presentation'){
                if(this.target.video_link){
                  this.checkVideoStatus(this.target.video_link)
                }
                return this.target.video_link ? this.target.video_link : null; //example  https://player.vimeo.com/video/429297333?title=0&byline=0&portrait=0
              } else {
                return null
              }

            },

            uploadId() {
                if(this.type == 'session') {
                return this.target.sessID;
                } else if (this.type=='presentation') {
                return this.target.pivot.lprID;
                } else {
                return -1
                }
            }
        },

        methods: {
            ...mapMutations('videoUpload', ['setVideoFile']),
            ...mapActions('videoUpload', ['removeVideo', 'submitFileWithTus', 'setVideo', 'setVideodescription', 'submitFileWithVimeoApproach', 'clearUpload','checkVideoStatus']),
            ...mapActions(['confirm']),

            cancelUpload() {
                this.file = null;
                this.checked = false;
                this.fileInputText = 'canceled upload';
                this.durationCheck = false;
                this.errorText = ''
            },

          reloadPage(){
            location.reload(true);
            //this.$router.push('/overview')
          },

            loadVideo(file) {
                let wrongFileType = 'invalid type';
                return new Promise((resolve, reject) => {
                    try {
                        let video = document.createElement('video')
                        video.preload = 'metadata'

                        video.onloadedmetadata = async function () {

                            while (video.duration === Infinity) {
                                await new Promise(r => setTimeout(r, 200));
                                video.currentTime = 10000000 * Math.random();
                            }
                            if (video.duration != 'Infinity') {
                                console.log(video.duration);
                                resolve(this)
                            }
                        }
                        video.onerror = function () {
                            reject(wrongFileType)
                        }
                        video.src = window.URL.createObjectURL(file)
                    } catch (e) {
                        reject(e)
                    }
                })
            },

            async handleFileUpload(event, id) {
                let ref = document.getElementById('file' + id);
                if (ref && ref.files && ref.files[0]) {
                    this.file = ref.files[0];
                    try {
                        //const video = await this.loadVideo(ref.files[0])
                        //let duration = video.duration.toFixed(2);
                        //let preslength = this.target.duration * 60;
                        //if (duration > preslength) {
                          //  this.errorText = this._.upload_file_too_large + this.target.duration + this._.upload_file_too_large_append;
                        //} else {
                            this.setVideo(ref.files[0]);
                            this.durationCheck = true;
                            this.fileInputText = this.videoName;
                            this.errorText = ''
                        //}
                    } catch (err) {
                        console.log(err);
                        this.durationCheck = false;
                        this.errorText = err
                    }
                }
            },

            async clearVideo(participation) {
                await this.confirm('Are you sure you want to delete this video');
                this.removeVideo({participation:participation, type:this.type});
                this.file = null;
                this.checked = false;
                this.fileInputText = 'Upload video';
                this.durationCheck = false;
                this.errorText = ''
            },

            async clearVideoUpload(participation) {
                await this.confirm('Do you want to abort the upload');
                this.clearUpload({participation:participation, type:this.type})

            },
        }
    };
</script>
<style lang="scss">
    @import '@/assets/scss/vue-filemanager';

    figure {
        max-width: 480px;
        max-height: 320px;
        height: 100%;
        margin: 5px 5px;
        padding: 5px 0 0 0;
        background-color: rgb(33, 33, 33);
    }

    .upload-progress {
        width: 100%;
        background: lightgrey;
        border-radius: 5px;
    }

    .progress-bar {
        border-radius: 5px;
    }


</style>

